module.exports = __webpack_public_path__ + "static/media/logo.2d6c92e9.png";